/**
 * URL 관련 유틸리티 함수들
 */

import { getEnvConfig } from "@configs/env";

/**
 * 현재 URL에서 쿼리 파라미터를 모두 제거하고 깨끗한 URL로 변경
 * 브라우저 히스토리에 새로운 엔트리를 추가하지 않고 현재 엔트리를 교체
 */
export const cleanUrlParams = (): void => {
  const { protocol, host, pathname } = window.location;
  const cleanUrl = `${protocol}//${host}${pathname}`;
  window.history.replaceState({}, document.title, cleanUrl);
};

/**
 * URL에서 특정 쿼리 파라미터 값을 추출
 * @param paramName - 추출할 파라미터 이름
 * @returns 파라미터 값 또는 null
 */
export const getUrlParam = (paramName: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};

/**
 * URL에 에러 파라미터가 있는지 확인
 * @returns 에러 파라미터 값 또는 null
 */
export const getUrlError = (): string | null => {
  return getUrlParam("error");
};

export const getDomainFromBaseUrl = () => {
  const { COMPANY_ID, BASE_URL, MODE } = getEnvConfig();
  if (MODE !== "product") {
    return "";
  }

  const companyId = COMPANY_ID;
  const baseUrl = BASE_URL;

  if (!baseUrl || !companyId) {
    return "";
  }

  // VITE_BASE_URL에서 도메인 부분 추출 (예: https://api.splitter.zcloud.click -> splitter.zcloud.click)
  let domain = baseUrl.replace(/^https?:\/\//, "");

  // 회사별 서브도메인 제거 규칙 적용
  switch (companyId) {
    case "MEGAZONE": {
      // api.megazone.com -> .megazone.com
      if (domain.startsWith("api.")) {
        domain = domain.replace(/^api\./, "");
      }
      break;
    }
    case "KT_DS": {
      // api.kt-ds.com -> .kt-ds.com
      if (domain.startsWith("api.")) {
        domain = domain.replace(/^api\./, "");
      }
      break;
    }
    case "ZENITH": {
      // splitter-api.zcloud.click -> .zcloud.click
      // api.splitter.zcloud.click -> .zcloud.click
      if (domain.startsWith("splitter-api.")) {
        domain = domain.replace(/^splitter-api\./, "");
      } else if (domain.startsWith("api.splitter.")) {
        domain = domain.replace(/^api\.splitter\./, "");
      } else if (domain.startsWith("api.")) {
        domain = domain.replace(/^api\./, "");
      }
      break;
    }
    default: {
      // 기본 로직: api만 제거
      if (domain.startsWith("api.")) {
        domain = domain.replace(/^api\./, "");
      }
      break;
    }
  }

  // 도메인이 .으로 시작하지 않으면 추가
  if (!domain.startsWith(".")) {
    domain = `.${domain}`;
  }

  return `domain=${domain}`;
};
